export class AccountantApiError extends Error {
  status: number

  constructor(status: number) {
    super(`Request failed with status ${status}`)
    this.status = status
  }
}

export const csrfToken = (): string => {
  const meta = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
  return meta ? meta.content : ''
}

export default function request<T = any>(path: string, options: { method?: string, body?: object } = {}): Promise<T> {
  return fetch(path, {
    method: options.method || 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken(),
    },
    credentials: 'same-origin',
    body: options.body ? JSON.stringify(options.body) : undefined,
  }).then(res => {
    if (res.status === 401) {
      window.location.assign('/sign_in')
      throw new AccountantApiError(res.status)
    }
    if (res.status === 403) {
      window.location.assign('/password/change')
      throw new AccountantApiError(res.status)
    }
    // 422 carries `{ errors }` for forms; every other failure is thrown.
    if (!res.ok && res.status !== 422) throw new AccountantApiError(res.status)

    return res.json()
  })
}
